import MuiDrawer from "@mui/material/Drawer";
import { drawerStyles } from "./Drawer.styles";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DivideBillEqually from "./layouts/DivideBillEqually";
import PayCustomAmount from "./layouts/PayCustomAmount";
import PayForYourItems from "./layouts/PayForYourItems";
import DrawerLayout from "./layouts/DrawerLayout";
import { useTranslation } from "react-i18next";
import ExtraTip from "./layouts/ExtraTip/ExtraTip";
import LeaveTip from "./layouts/LeaveTip/LeaveTip";
import ConfirmAndPay from "./layouts/ConfirmAndPay/ConfirmAndPay";
import OrderTip from "./layouts/OrderTip/OrderTip";
import OrderPayment from "./layouts/OrderPayment/OrderPayment";

function Drawer() {
  const location = useLocation();
  const { t } = useTranslation();
  const lastPathElement = location.pathname.split("/").pop();

  const [drawerContent, setDrawerContent] = useState<JSX.Element | null>(null);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    switch (lastPathElement) {
      case "leave-tip":
        setDrawerContent(<LeaveTip />);
        setDrawerTitle(t("gradientDrawer.leaveTip.title"));
        break;
      // Ordering checkout. Distinct segments from the bill-splitting flow so
      // neither drawer can be opened by the other's URL.
      case "tip":
        setDrawerContent(<OrderTip />);
        setDrawerTitle(t("order.tip.title"));
        break;
      case "payment":
        setDrawerContent(<OrderPayment />);
        setDrawerTitle(t("order.payment.title"));
        break;
      case "extra-tip":
        setDrawerContent(<ExtraTip />);
        setDrawerTitle(t("gradientDrawer.extraTip.title"));
        break;
      case "pay-for-your-items":
        setDrawerContent(<PayForYourItems />);
        setDrawerTitle(t("gradientDrawer.payForYourItems.title"));
        break;
      case "custom":
        setDrawerContent(<PayCustomAmount />);
        setDrawerTitle(t("gradientDrawer.payACustomAmount.title"));
        break;
      case "equally":
        setDrawerContent(<DivideBillEqually />);
        setDrawerTitle(t("gradientDrawer.divideBillEqually.title"));
        break;
      case "confirm-and-pay":
        setDrawerContent(<ConfirmAndPay />);
        setDrawerTitle(t("gradientDrawer.confirmAndPay.title"));
        break;
      default:
        break;
    }
  }, [location.pathname]);

  useEffect(() => {
    const isOpen =
      lastPathElement === "equally" ||
      lastPathElement === "custom" ||
      lastPathElement === "pay-for-your-items" ||
      lastPathElement === "extra-tip" ||
      lastPathElement === "confirm-and-pay" ||
      lastPathElement === "checkout-fee" ||
      lastPathElement === "leave-tip" ||
      lastPathElement === "payment-error" ||
      lastPathElement === "tip" ||
      lastPathElement === "payment";

    setDrawerOpen(isOpen);
  }, [location.pathname]);

  return (
    <MuiDrawer
      sx={drawerStyles}
      anchor="bottom"
      open={drawerOpen}
      transitionDuration={{ enter: 900, exit: 900 }}
      hideBackdrop
      ModalProps={{
        keepMounted: true,
      }}
    >
      <DrawerLayout closeDrawer={closeDrawer} title={drawerTitle}>
        {drawerContent}
      </DrawerLayout>
    </MuiDrawer>
  );
}

export default Drawer;
